export default __webpack_public_path__ + "static/media/100_44755.5ec3a3ad.jpg";